// @flow

import type {
  DictionaryItem,
  Dispute,
  DisputeSort,
  Features,
  PaymentMethod
} from '../../containers/disputes/types';
import type {RootState} from '../types';
import type {DictionaryStorage, DisputesState, Filter, ReportStore, TableStore} from './types';

const selectNamespace = (state: RootState): DisputesState => state.disputes;

const selectTable = (state: RootState): TableStore => selectNamespace(state).table;

const selectTableRow = (state: RootState) => selectTable(state).row;

const selectDictionary = (state: RootState): DictionaryStorage => selectNamespace(state).dictionary;

export const selectTableRowsCount = (state: RootState): number => selectTableRow(state).count;

export const selectTableDisputes = (state: RootState): Array<Dispute> =>
  selectTableRow(state).disputes;

export const selectTableCurrentPage = (state: RootState): number => selectTable(state).currentPage;

export const selectTableFetching = (state: RootState): boolean => selectTable(state).fetching;

export const selectTableFilter = (state: RootState): Filter => selectTable(state).filter;

export const selectProjects = (state: RootState): Array<DictionaryItem> =>
  selectDictionary(state).projects;

export const selectPaymentMethods = (state: RootState): Array<PaymentMethod> =>
  selectDictionary(state).paymentMethods;

export const selectReport = (state: RootState): ReportStore => selectNamespace(state).report;

export const selectTableDisputesSort = (state: RootState): DisputeSort => selectTable(state).sort;

export const selectSettingsMerchantID = (state: RootState): number =>
  selectNamespace(state).settings.merchantID;

const selectDisputeFeatures = (state: RootState): Features =>
  selectNamespace(state).features.disputeFeatures;

export const selectFeatureProtectUserIdField = (state: RootState): boolean =>
  selectDisputeFeatures(state).some(
    feature => feature.name === 'user_protection' && feature.enabled
  );

// Evidence selectors
const selectEvidence = (state: RootState) => selectNamespace(state).evidence;

export const selectEvidenceUploading = (state: RootState): boolean =>
  selectEvidence(state).isUploadingEvidence;

export const selectEvidenceError = (state: RootState): ?string =>
  selectEvidence(state).evidenceError;
